import { useState } from 'react'

export const useHome = () => {
  const [currentTab, setCurrentTab] = useState<'overview' | 'personalization'>(
    'overview',
  )

  return {
    currentTab,
    setCurrentTab,
  }
}
